import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { EDIShippingNotesByPartReportDto } from "@interfaces/dto/reports/ediShippingNotesByPartReportDto.interface";
import { PartService } from "@services/part.service";
import { ReportService } from "@services/report.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "ediShippingNotesByPart",
	styleUrls: ["ediShippingNotesByPart.css"],
	templateUrl: "ediShippingNotesByPart.html"
})
export class EDIShippingNotesByPartReportAdminComponent {
	headerPrimaryButtons: AdminHeaderButton[] = [{ icon: "fal fa-chart-line", method: "close", text: "Reports" }];
	headerSecondaryButtons: AdminHeaderButton[] = [{ icon: "fal fa-envelope-open-text", method: "generateReport", text: "Generate & Email Report" }];
	parameters: EDIShippingNotesByPartReportDto = new EDIShippingNotesByPartReportDto();
	parts: any[] = [];
	title = "EDI Shipping Notes by Part";

	constructor(private partService: PartService, private reportService: ReportService, private router: Router, private toastService: ToastService) {
		this.getParts();
	}

	close() {
		this.router.navigate(["admin/menu/reports/"]);
	}

	generateReport() {
		this.reportService.ediShippingNotesByPart(this.parameters)
			.subscribe(
				() => this.toastService.success("Report Queued - Please await results by email."),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getParts() {
		this.partService.getAll()
			.subscribe(
				(res: any) => {
					this.parts = res.response?.items || res.response || [];
					this.partService.allParts.next(this.parts);
				},
				(err) => console.log(err)
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}
}
